export const dispatchHelper = {
    methods: {
        getCompletionTime(dispatchItem) {
            let completion
            let completedAssignments = 0
            let result
            dispatchItem.work_assignments.forEach((assignment => {
                if (assignment.closing_date && assignment.closing_date.length > 0) {
                    completedAssignments++
                    let closing = new Date(assignment.closing_date)
                    if (!completion || closing.getTime() > completion.getTime()) {
                        completion = closing
                        result = assignment.closing_date
                    }
                }
            }))

            if (completion && dispatchItem.work_assignments.length > 0 && dispatchItem.work_assignments.length === completedAssignments) {
                return result
            }
            return null
        },

        isDelayed(dispatchItem) {
           const target = new Date(dispatchItem.deadline)
           const complete = dispatchItem.completed ? new Date(dispatchItem.completed) : new Date()
           return complete.getTime() > target.getTime()
        },


        getStatus(dispatchItem) {
            const totalAssignents = dispatchItem.work_assignments.length
            let completedAssignments = 0
            dispatchItem.work_assignments.forEach((assignment => {
                if (assignment.closing_date && assignment.closing_date.length > 0) {
                    completedAssignments++
                }
            }))
            return totalAssignents > 0 ? (Math.round(completedAssignments/totalAssignents * 100) ) : 0
        },

    }
}
